var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgGoogle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 17 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.196 15.044c2.022-1.887 2.92-5.032 2.381-8.043H8.535v3.325h4.583c-.18 1.079-.809 1.977-1.708 2.561l2.786 2.157Z",
  fill: "#4285F4"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M.897 12.393a8.729 8.729 0 0 0 1.07 1.625 8.638 8.638 0 0 0 4.936 2.93 8.675 8.675 0 0 0 2.91.08 8.679 8.679 0 0 0 2.77-.894 8.59 8.59 0 0 0 1.613-1.09l-2.786-2.157c-2.38 1.573-6.335.989-7.683-2.696l-2.83 2.202Z",
  fill: "#34A853"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.727 10.191c-.359-1.123-.359-2.156 0-3.28L.897 4.71c-1.034 2.067-1.348 4.987 0 7.683l2.83-2.202Z",
  fill: "#FBBC02"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.727 6.911c.989-3.1 5.212-4.897 8.043-2.246l2.471-2.426C10.736-1.131 3.907-.996.897 4.709l2.83 2.202Z",
  fill: "#EA4335"
})));

export default SvgGoogle;